var AbstractViewModel = require("./AbstractViewModel")
 
function ServiceResultViewModel(parent) {
  var self = this;

  // Predicate this ViewModel on the Abstract class of a View Model
  // This tacks on additional functionality, including the ability to
  // read URL query parameters, and an observable binding predicated
  // on another object's obcervable-bound variables
  AbstractViewModel.apply(this, arguments);

  self._deferred = null;
  self.visible = ko.observable(false);
  self.callback = null;
  self.canCancel = ko.observable(true);
  self.transaction = ko.observable(null);
  self.doCheckInServicedCheck = null;
  self.dummy = ko.observable(null);
  // Magic number - relates to a limit in reporting
  self.numericServiceMax = 10;
  self.okCallback = null;
  self.queue = null;
  self.valid = ko.observable(false);


	/**
	 * Checks to ensure that the oneTransactionType property is respected
	 *
	 * @method checkInput
	 * @param {Model} data
	 * @param {KeyboardEvent | MouseEvent}
	 * @returns {Boolean}
	 */
  self.checkInput = function (data, evt) {
    var id = evt.target.id;

    // Ensure that only numbers can be entered. Returning false will 
    // prevent the character from being entered
    if (self.numericServiceResults() && (!(self.parent.isNumericInput(evt) || evt.keyCode === 8))) {
      return false;
    }

    // If the oneTransactionType should be enforced, clear any other
    // values that are not the one that invoked this handler
    if (self.oneTransactionType() === true) {
      // Look for at least one value
      // Start by looping over the service results types
      self.serviceResults().forEach(function (sr) {
        // Pull the service result id
        var sid = sr.id;

        // Now loop over the transaction types
        self.transactionTypes().forEach(function (tt) {
          // Pull the transaction type id
          var tid = tt.id;

          // If the value is not the one which invoked this action,
          // clear it
          if ('sr-' + sid + '-' + tid != id) {
            // Clear the observable
            self.parent.dynamicObservable('sr-' + sid + '-' + tid, null);
            // Also clear the notes field
            self.parent.dynamicObservable('srnotes-' + sid + '-' + tid, null);
          }
        });

      });
    }

    self.checkValid();

    return true;
  };


	/**
	 * Determines if the form is valid and can be submitted to the
   * API service
	 *
	 * @method checkValid
	 * @returns none
	 */
  self.checkValid = function () {
    var valid = false;

    self.dummy.notifySubscribers();

    // Look for at least one value
    // Start by looping over the service results types
    self.serviceResults().forEach(function (sr) {
      // Pull the service result id
      var sid = sr.id;

      // Now loop over the transaction types
      self.transactionTypes().forEach(function (tt) {
        // Pull the transaction type id
        var tid = tt.id;

        // TODO improve this hack for value checking.
        // Seems like there is some race condition with data-binding
        // Get the value
        var val = (self.numericServiceResults()) ? document.getElementById('sr-' + sid + '-' + tid).value : document.getElementById('sr-' + sid + '-' + tid).checked;

        // If there is a value, then the default result will be true
        if (val && val !== '') {
          valid = true;

          if (tt.notesRequired && tt.notesRequired === true && self.parent.dynamicObservable('srnotes-' + sid + '-' + tid)() === '') {
            valid = false;
          }

        }
      });

    });

    self.valid(valid);
  };


	/**
	 * Hides the service detail UI
	 *
	 * @method detailHide
	 * @returns none
	 */
  self.detailHide = function () {
    self.reset();
  };


	/**
	 * Presents the service detail UI
	 *
	 * @method detailShow
	 * @param {Object} transaction
	 * @param {Boolean} bDoCheckInServicedCheck
	 * @param {Function} fServiceDetailOKCallback
   * @returns {JQueryPromise} jQuery Deferred which resolves when the dialog is closed.
	 */
  self.detailShow = function (transaction, fCallback) {
    self.transaction(transaction || self.parent.currentlyServicing()[0]);

    if (fCallback === true) {
      self.canCancel(false);
    }
    else {
      self.callback = fCallback;
    }

    self.queue = self.parent.queuesWS.getQueueById(self.transaction().spot.queueId);

    if (self.serviceResults().length > 0) {
      self.parent.showServiceResults(true);
      self.setObservables();
    }

    self._deferred = window.jQuery.Deferred(function (defer) {
      self.visible(true);
    });

    return self._deferred.promise();
  };


  /**
   * Ends the service results dialogue and ends the service
   *
   * @method endService
   * @returns none
   */
  self.endService = function () {
    var details = self.serviceValues();
    var endServiceWS = self.parent.endServiceTransactionWS;
    var suppress = false;

    if (!self.okButtonEnabled()) {
      return false;
    }

    if (self.numericTotalExceedsMax()) {
      return;
    }

    if (details.length > self.numericServiceMax) {
      // TODO - and why can we only accept 10 values?
      // tooManyDetails.open();
      // return;
      details = details.slice(0, 9)
    }

    endServiceWS.clearParams();

    if (self.parent.preCheckSpot() && self.parent.successor()) {
      self.parent.showMakeEligible(true);
    }

    if (self.doCheckInServicedCheck) {
      // If a transaction type with removeSpotsInOtherQueues is selected,
      // then don't show the checkedInServiced dialog, since the spot
      // to check it will be removed
      if (details && details.length > 0) {
        details.forEach(function (val) {
          if (val) {
            var idx = val.indexOf('-');

            if (idx !== -1 && (idx + 1) < val.length) {
              var q = self.queue,
                t = (q) ? q.transactionTypes.find(function (t) {
                  return t.id === val.substring(idx + 1);
                }) : null;

              if (t && t.removeSpotsInOtherQueues) {
                suppress = true;
              }
            }
          }
        });
      }

      if (!suppress) {
        if (self.parent.allowParallelServiceTransactions()) {
        }

        self.parent.checkInServicedself.parent.openIfNecessary();
      }
      else {
      }
    }

    details.forEach(function (val, idx) {
      if (idx < self.numericServiceMax) {
        endServiceWS.addParam('details-' + idx, val);
      }
    });

    // TODO - replace this with the transaction id for the spot model to end service for
    endServiceWS.addParam('transactionId', self.transaction().transactionId);

    if (self.okCallback) {
      self.okCallback();
      self.okCallback = null;
    }
    else {
      self.parent.showServiceResults(false);
    }

    if (self.callback) {
      self.callback();
    }
    else {
      self.parent.doEndServiceTransactionWS(function () {
        self._deferred.resolve(self.serviceValues());
        self.reset();
      });
    }
  }


	/**
	 * Indicates whether the service results should be shows as checkbox
   * (false) or text inputs (true)
	 *
	 * @method numericServiceResults
	 * @returns {Boolean}
	 */
  self.numericServiceResults = ko.computed(function () {
    var spot = (self.transaction()) ? self.transaction().spot : null;
    var q = (spot) ? self.parent.queuesWS.getQueueById(spot.queueId) : null;

    return q && q.numericServiceTransactions === true;
  });


  /**
   * Calculates the sum of all numeric service inputs
   *
   * @method numericServiceTotal
   * @returns {Number | Null}
   */
  self.numericServiceTotal = function () {
    var total = 0;

    if (!self.numericServiceResults()) {
      return null;
    }

    // Loop over each service result type
    self.serviceResults().forEach(function (sr) {
      // Pull the service result id
      let sid = sr.id;

      // Now loop over the transaction types
      self.transactionTypes().forEach(function (tt) {
        // Pull the transaction type id
        let tid = tt.id;

        // TODO improve this hack for value checking. Seems like there is some race condition with data-binding
        // Get the value
        var el = document.getElementById('sr-' + sid + '-' + tid);
        var val = el ? el.value : null;

        // If there is a value, then the default result will be true
        if (val && val !== '') {
          total += Number(val);
        }
      });
    });

    return total;
  };


  /**
   * Determines whether the numeric service total is greater than the
   * specified 'magic number'
   *
   * @method numericTotalExceedsMax
   * @returns {Boolean}
   */
  self.numericTotalExceedsMax = ko.computed(function () {
    var dum = self.dummy();
    return self.numericServiceTotal() > self.numericServiceMax;
  });


	/**
	 * Determines whether only a single service result can be provided
   * by the employee
	 *
	 * @method oneTransactionType
	 * @returns {Boolean}
	 */
  self.oneTransactionType = ko.computed(function () {
    // Computed Observable Hook
    var bundle = self.parent.messagesWS.bundle();

    return self.parent.messagesWS.get('serviceDetail.oneTransactionType') === 'true';
  });


	/**
	 * Resets the view model to a default state
	 *
	 * @method reset
	 * @returns none
	 */
  self.reset = function () {
    self._deferred = null;
    self.resetObservables();

    self.canCancel(true);
    self.transaction(null);
    self.doCheckInServicedCheck = null;
    self.okCallback = null;
    self.queue = null;

    self.valid(false);

    self.parent.showServiceResults(false);
  };


	/**
	 * Resets all observable values
	 *
	 * @method resetObservables
	 * @returns none
	 */
  self.resetObservables = function () {
    // Look for at least one value
    // Start by looping over the service results types
    self.serviceResults().forEach(function (sr) {
      // Pull the service result id
      var sid = sr.id;

      // Now loop over the transaction types
      self.transactionTypes().forEach(function (tt) {
        // Pull the transaction type id
        var tid = tt.id;

        // Unset the value
        self.parent.dynamicObservable('sr-' + sid + '-' + tid, null);
      });
    });
  };


	/**
	 * Abstract the service results so the UI only has to reach one
   * level down into objects
	 *
	 * @method serviceResults
	 * @returns {Array}
	 */
  self.serviceResults = ko.computed(function () {
    var arr = [];

    if (self.transaction() && self.transaction().spot.queue()) {
      arr = self.transaction().spot.queue().serviceResults;
    }

    return arr;
  });


	/**
	 * Polls all the service results for their values
	 *
	 * @method serviceValues
	 * @returns {Array}
	 */
  self.serviceValues = function () {
    var vals = [];

    // Start by looping over the service results types
    self.serviceResults().forEach(function (sr) {
      // Pull the service result id
      var sid = sr.id;

      // Now loop over the transaction types
      self.transactionTypes().forEach(function (tt) {
        // Pull the transaction type id
        var tid = tt.id;

        // Get the value
        var val = (self.numericServiceResults()) ? self.parent.dynamicObservable('sr-' + sid + '-' + tid)() : document.getElementById('sr-' + sid + '-' + tid) ? document.getElementById('sr-' + sid + '-' + tid).checked : null;
        var notes = self.parent.dynamicObservable('srnotes-' + sid + '-' + tid)() || '';

        // If there is a value, then the default result will be true
        if (val && val !== '') {
          val = (self.numericServiceResults()) ? Number(val) : 1;

          for (let i = 0; i < val; i++) {
            vals.push(sid + '-' + tid + '-' + notes);
          }

        }
      });

    });

    return vals;
  };


	/**
	 * Initializes the observables
	 *
	 * @method setObservables
	 * @returns none
	 */
  self.setObservables = function () {
    // Start by looping over the service results types
    self.serviceResults().forEach(function (sr) {
      // Pull the service result id
      let sid = sr.id;

      // Now loop over the transaction types
      self.transactionTypes().forEach(function (tt) {
        // Pull the transaction type id
        let tid = tt.id;

        // Get the value
        let val = self.parent.dynamicObservable('sr-' + sid + '-' + tid, null);
        let notes = self.parent.dynamicObservable('srnotes-' + sid + '-' + tid, null);
      });

    });
  }


	/**
	 * Creates the title for the UI
	 *
	 * @method title
	 * @returns none
	 */
  self.title = ko.computed(function () {
    var msg = self.parent.messagesWS.get('type.of.service.provided');
    var spot = (self.transaction()) ? self.transaction().spot : null;
    var name = (spot) ? spot.privateName() : '';

    return msg.replace('{0}', name);
  });


	/**
	 * Returns a list of transaction types
	 *
	 * @method transactionTypes
	 * @returns {Array}
	 */
  self.transactionTypes = ko.computed(function () {
    var spot = (self.transaction()) ? self.transaction().spot : null;
    var tts = [];


    if (spot) {
      var q = self.parent.queuesWS.getQueueById(spot.queueId);

      if (q) {
        // Set the array to the Transaction Types known by the q. This can be an empty array
        tts = q.transactionTypes;

        // If there are service transaction types, add those to the collection to be returned
        if (q.serviceTransactionTypes.length > 0) {
          tts = tts.concat(q.serviceTransactionTypes);
        }
      }
    }

    // return the collection
    return tts;
  });


  /**
   * Whether the OK button is enabled or not
   *
   * @method okButtonEnabled
   * @returns {Boolean}
   */
  self.okButtonEnabled = ko.computed(function () {
    var vals = self.serviceValues();
    var numericInBounds = self.numericServiceResults() ? !self.numericTotalExceedsMax() : true;

    return self.valid() && numericInBounds;
  });

  // Expose the object as it's own API
  return self;
};

module.exports = ServiceResultViewModel
